export default __webpack_public_path__ + "static/media/monkey3.bc3b3a28.JPG";